// extracted by mini-css-extract-plugin
module.exports = {"buttonBrand":"Button_buttonBrand__3rZa0","content":"Button_content__2yRgL","buttonBasic":"Button_buttonBasic__3UmE1"};